"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointHeadersIn = void 0;
class EndpointHeadersIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EndpointHeadersIn.attributeTypeMap;
    }
}
exports.EndpointHeadersIn = EndpointHeadersIn;
EndpointHeadersIn.discriminator = undefined;
EndpointHeadersIn.attributeTypeMap = [
    {
        "name": "headers",
        "baseName": "headers",
        "type": "{ [key: string]: string; }",
        "format": ""
    }
];
//# sourceMappingURL=EndpointHeadersIn.js.map